<template>
  <span :class="badgeClass">
    <i :class="iconClass"></i>
    {{ statusText }}
  </span>
</template>

<script>
export default {
  name: 'BillingStatusBadge',

  props: {
    tenant: {
      type: Object,
      required: true,
    },
  },

  computed: {
    isConfigured() {
      return Boolean(this.tenant.billing_type)
    },

    hasRequiredData() {
      if (!this.isConfigured) return false

      const { billing_type: billingType, billing_fixed_value: billingFixedValue, billing_per_user_value: billingPerUserValue, billing_user_ranges: billingUserRanges } = this.tenant

      switch (billingType) {
        case 'fixed_value':
          return Boolean(billingFixedValue)
        case 'per_active_user':
          return Boolean(billingPerUserValue)
        case 'user_range':
          return Array.isArray(billingUserRanges) && billingUserRanges.length > 0
        default:
          return false
      }
    },

    badgeClass() {
      if (!this.isConfigured) return 'badge badge-secondary'
      if (this.hasRequiredData) return 'badge badge-success'
      return 'badge badge-warning'
    },

    iconClass() {
      if (!this.isConfigured) return 'fa fa-times-circle'
      if (this.hasRequiredData) return 'fa fa-check-circle'
      return 'fa fa-exclamation-triangle'
    },

    statusText() {
      if (!this.isConfigured) return 'Não config.'
      if (this.hasRequiredData) return 'Configurado'
      return 'Incompleto'
    },
  },
}
</script>
